import FetchedCorrectiveImageCard from '@/modules/adjusterReportModules/IncidentParticipants/components/images/property/damaged/correctiveImages/components/fetchedImages/components/fetchedCorrectiveImageCard/FetchedCorrectiveImageCard';
import WrapperCorrectiveImagesList from '@/modules/adjusterReportModules/IncidentParticipants/components/images/property/damaged/correctiveImages/components/fetchedImages/components/WrapperCorrectiveImagesList/WrapperCorrectiveImagesList';
import { getRecievedCorrectiveImagesOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getRecievedCorrectiveImages/getRecievedCorrectiveImagesOptions';
import { postAcceptOrRejectRecievedImagesOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postAcceptOrRejectRecievedImages/postAcceptOrRejectRecievedImagesOptions';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { Box, Flex } from 'styled-system/jsx';
import NoRecievedImagesIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/noRecievedImagesIcon.svg?react';
import Typography from '@/common/components/base/typography/Typography';
import { FileTypeConst } from '@/common/types/Files.type';
const FetchedImages = ({ type }: { type?: FileTypeConst }) => {
  const { damagedId, id } = useParams();
  const { data: fetchedData } = useQuery(
    getRecievedCorrectiveImagesOptions({
      damaged_id: +damagedId!,
      id: +id!,
      type: type,
    }),
  );
  const { mutate, isPending } = useMutation(
    postAcceptOrRejectRecievedImagesOptions(),
  );
  return fetchedData?.damaged.length! > 0 ||
    fetchedData?.documents?.length! > 0 ||
    fetchedData?.vehicle?.length! > 0 ? (
    <Flex direction={'column'} gap={'2rem'} mt={16}>
      {fetchedData?.documents?.length! > 0 && (
        <WrapperCorrectiveImagesList headerTitle="مدارک فردی">
          {fetchedData?.documents.map((item) => (
            <FetchedCorrectiveImageCard
              image={item.image}
              key={item.id}
              title={item.title?.fa_const}
              accept={() =>
                mutate({
                  damaged_id: +damagedId!,
                  data: {
                    accepted: true,
                    image_id: item.id,
                    is_damaged: false,
                  },
                  id: +id!,
                })
              }
              reject={() =>
                mutate({
                  damaged_id: +damagedId!,
                  data: {
                    accepted: false,
                    image_id: item.id,
                    is_damaged: false,
                  },
                  id: +id!,
                })
              }
              acceptLoading={isPending}
              rejectLoading={isPending}
            />
          ))}
        </WrapperCorrectiveImagesList>
      )}
      {fetchedData?.vehicle?.length! > 0 && (
        <WrapperCorrectiveImagesList headerTitle="فیلم و تصاویر وسیله‌نقلیه">
          {fetchedData?.vehicle.map((item) => (
            <FetchedCorrectiveImageCard
              image={item.image}
              key={item.id}
              title={item.title?.fa_const}
              accept={() =>
                mutate({
                  damaged_id: +damagedId!,
                  data: {
                    accepted: true,
                    image_id: item.id,
                    is_damaged: false,
                  },
                  id: +id!,
                })
              }
              reject={() =>
                mutate({
                  damaged_id: +damagedId!,
                  data: {
                    accepted: false,
                    image_id: item.id,
                    is_damaged: false,
                  },
                  id: +id!,
                })
              }
              acceptLoading={isPending}
              rejectLoading={isPending}
            />
          ))}
        </WrapperCorrectiveImagesList>
      )}
      {fetchedData?.damaged?.length! > 0 && (
        <WrapperCorrectiveImagesList headerTitle="نقاط اسیب دیده">
          {fetchedData?.damaged.map((item) => (
            <FetchedCorrectiveImageCard
              image={item.image}
              key={item.id}
              title={item.title?.fa_const}
              accept={() =>
                mutate({
                  damaged_id: +damagedId!,
                  data: {
                    accepted: true,
                    image_id: item.id,
                    is_damaged: false,
                  },
                  id: +id!,
                })
              }
              reject={() =>
                mutate({
                  damaged_id: +damagedId!,
                  data: {
                    accepted: false,
                    image_id: item.id,
                    is_damaged: false,
                  },
                  id: +id!,
                })
              }
              acceptLoading={isPending}
              rejectLoading={isPending}
            />
          ))}
        </WrapperCorrectiveImagesList>
      )}
    </Flex>
  ) : (
    <Box
      w="100%"
      h="60vh"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={16}
    >
      <NoRecievedImagesIcon />
      <Typography color="black-3" textStyle="b2">
        تصویری دریافت نشده است !
      </Typography>
    </Box>
  );
};

export default FetchedImages;
